import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/29.png";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import React from "react";

export const PersonKambarova = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Камбарова Жулдуз Думанбековна</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>Master of Geoecology</MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», главный менеджер департамента науки и инноваций</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Менеджер проекта</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ведение документации по проекту, оформление командировок;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Коммуникация с контролирующими органами, составление писем;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Заключение договоров, включая соглашения по коммерциализации технологий.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Специалист с 24-летним стажем в сфере коммерциализации технологий. Опыт маркетинговых исследований, сопровождения договоров по интеллектуальной собственности.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Опыт проектов:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проект технологии картирования на шельфе Каспийского моря (2013-2015), бюджет $974 983.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Центр компетенций «Электронная промышленность» — менеджер проекта, бюджет 275 000 000 тенге.
                </MyText>
            </Flex>
        </Flex>
    );
};
